module.exports = __webpack_public_path__ + "fonts/db_helvethaicaais_x_bd_v3.2-webfont.962ef1f2.eot";